import { useEffect } from 'react'

type UseMutationObserverParams = {
  options: MutationObserverInit
  callback: MutationCallback
}

export const useMutationObserver = (params: UseMutationObserverParams) => {
  const { options, callback } = params

  useEffect(() => {
    const { body } = document

    const observer = new MutationObserver(callback)
    observer.observe(body, options)
    return () => {
      observer.disconnect()
    }
  }, [callback, options])
}
